import { CustomFieldType } from 'entities/CustomField/api/types'

export const FieldTypeConfig = {
  [CustomFieldType.Number]: { label: 'Number', icon: 'number' },
  [CustomFieldType.Text]: { label: 'Text', icon: 'textInput2' },
  [CustomFieldType.Url]: { label: 'URL', icon: 'link' },
  [CustomFieldType.Date]: { label: 'Date', icon: 'calendar' },
  [CustomFieldType.DateTime]: { label: 'Date & Time', icon: 'calendarClock' },
} as const
